import React, { useState } from "react";
import { Row, Col, Button, Alert, Container, Label } from "reactstrap";
import { AvForm, AvField } from "availity-reactstrap-validation";

import { Link, useNavigate } from "react-router-dom";

// images
import logodark from "../../assets/images/logo-dark.png";
import { getRecords } from "../../services/api.service";

const Register = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    role_id: 2,
    username: "",
    password: "",
    first_name: "",
    last_name: "",
    mobile_no: "",
    email: "",
    state: 1,
    country: 1,
    city: 1,
    isActive: 1,
  });
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [registrationStatus, setRegistrationStatus] = useState("");
  const [message, setMessage] = useState("");
  const handleChange = (e) => {
    setMessage("");
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Submit Handler
  const handleSubmit = async () => {
    setLoading(true);
    setMessage("");
    try {
      const payload = {
        modelName: "UserMaster",
        whereCondition: {
          email: formData.email,
        },
        inputData: formData,
        schema: "public",
      };

      const response = await getRecords(payload, "/auth/signup");
      setRegistrationStatus(response.status);
      setMessage(response.message);
      if (response?.status) {
        navigate("/login");
      }
    } catch (error) {
      console.error("Login error:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <React.Fragment>
      <div>
        <Container fluid className="p-0">
          <Row className="g-0">
            <Col lg={4}>
              <div className="authentication-page-content p-4 d-flex">
                <div className="w-100">
                  <Row className="justify-content-center">
                    <Col lg={9}>
                      <div>
                        <div className="text-center">
                          <div>
                            <Link to="#" className="logo">
                              <img
                                src="https://logicloom.in/wp-content/uploads/2023/05/LogicLoom-2-04.png"
                                height="20"
                                alt="logo"
                              />
                            </Link>
                          </div>

                          <h4 className="font-size-18 mt-4">
                            Register account
                          </h4>
                          <p className="text-muted">
                            Get your free Nazox account now.
                          </p>
                        </div>

                        <div className="p-2 mt-5">
                          <AvForm
                            onValidSubmit={handleSubmit}
                            className="form-horizontal"
                          >
                            {/* EMAIL */}
                            <div className="auth-form-group-custom mb-4">
                              <i className="ri-mail-line auti-custom-input-icon"></i>
                              <Label>Email</Label>
                              <AvField
                                name="email"
                                type="email"
                                value={formData.email}
                                onChange={handleChange}
                                validate={{
                                  required: {
                                    value: true,
                                    errorMessage: "Email is required",
                                  },
                                  pattern: {
                                    value:
                                      "^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$",
                                    errorMessage: "Please enter a valid email",
                                  },
                                }}
                                className="form-control"
                                placeholder="Enter email"
                              />
                            </div>

                            {/* USERNAME */}
                            <div className="auth-form-group-custom mb-4">
                              <i className="ri-user-2-line auti-custom-input-icon"></i>
                              <Label>Username</Label>
                              <AvField
                                name="username"
                                type="text"
                                value={formData.username}
                                onChange={handleChange}
                                validate={{
                                  required: true,
                                  pattern: {
                                    value: "^.{4,}$",
                                    errorMessage:
                                      "Username must be at least 4 characters",
                                  },
                                }}
                                className="form-control"
                                placeholder="Enter username"
                              />
                            </div>

                            {/* FIRST NAME */}
                            <div className="auth-form-group-custom mb-4">
                              <i className="ri-user-line auti-custom-input-icon"></i>
                              <Label>First Name</Label>
                              <AvField
                                name="first_name"
                                type="text"
                                value={formData.first_name}
                                onChange={handleChange}
                                validate={{
                                  required: {
                                    value: true,
                                    errorMessage: "First name is required",
                                  },
                                }}
                                className="form-control"
                                placeholder="Enter first name"
                              />
                            </div>

                            {/* LAST NAME */}
                            <div className="auth-form-group-custom mb-4">
                              <i className="ri-user-line auti-custom-input-icon"></i>
                              <Label>Last Name</Label>
                              <AvField
                                name="last_name"
                                type="text"
                                value={formData.last_name}
                                onChange={handleChange}
                                validate={{
                                  required: {
                                    value: true,
                                    errorMessage: "Last name is required",
                                  },
                                }}
                                className="form-control"
                                placeholder="Enter last name"
                              />
                            </div>

                            {/* MOBILE */}
                            <div className="auth-form-group-custom mb-4">
                              <i className="ri-phone-line auti-custom-input-icon"></i>
                              <Label>Mobile Number</Label>
                              <AvField
                                name="mobile_no"
                                type="text"
                                value={formData.mobile_no}
                                onChange={handleChange}
                                validate={{
                                  required: true,
                                  pattern: {
                                    value: "^[0-9]{10}$",
                                    errorMessage:
                                      "Enter valid 10-digit mobile number",
                                  },
                                }}
                                className="form-control"
                                placeholder="Enter mobile number"
                              />
                            </div>

                            {/* PASSWORD */}
                            <div className="auth-form-group-custom mb-4">
                              <i className="ri-lock-2-line auti-custom-input-icon"></i>
                              <Label>Password</Label>
                              <AvField
                                name="password"
                                type={passwordVisible ? "text" : "password"}
                                value={formData.password}
                                onChange={handleChange}
                                validate={{
                                  required: {
                                    value: true,
                                    errorMessage: "Password is required",
                                  },
                                  minLength: {
                                    value: 6,
                                    errorMessage:
                                      "Password must be at least 6 characters",
                                  },
                                }}
                                className="form-control"
                                placeholder="Enter password"
                              />
                              {formData.password?.length !== 0 && (
                                <button
                                  type="button"
                                  onClick={() =>
                                    setPasswordVisible(!passwordVisible)
                                  }
                                  style={{
                                    position: "absolute",
                                    top: "54%",
                                    right: "30px",
                                    transform: "translateY(-50%)",
                                    background: "transparent",
                                    border: "none",
                                    cursor: "pointer",
                                  }}
                                >
                                  {passwordVisible ? (
                                    <i
                                      className="ri-eye-line"
                                      style={{ fontSize: "1.2em" }}
                                    ></i>
                                  ) : (
                                    <i
                                      className="ri-eye-off-line"
                                      style={{ fontSize: "1.2em" }}
                                    ></i>
                                  )}
                                </button>
                              )}
                            </div>

                            {message.length > 0 && (
                              <div className="mt-4 mb-4 text-center">
                                <span
                                  className={
                                    registrationStatus
                                      ? "text-success"
                                      : "text-danger"
                                  }
                                >
                                  {message}
                                </span>
                              </div>
                            )}
                            <div className="text-center">
                              <Button
                                color="primary"
                                className="w-md waves-effect waves-light"
                                type="submit"
                              >
                                {loading ? "Loading ..." : "Register"}
                              </Button>
                            </div>
                          </AvForm>
                        </div>

                        <div className="mt-5 text-center">
                          <p>
                            Already have an account ?{" "}
                            <Link
                              to="/login"
                              className="fw-medium text-primary"
                            >
                              {" "}
                              Login
                            </Link>
                          </p>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </div>
              </div>
            </Col>

            <Col lg={8}>
              <div className="authentication-bg"></div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Register;
